function createRedirectLink(
	env,
	patientID,
	prescriptionsCount,
	patientToken,
	discount = null
) {
	let redirectLink;
	if (prescriptionsCount > 0) {
	if (discount != null) {
		redirectLink =
		env +
		".ottooptics.io/reorder/rxselect/?id=" +
		patientID +
		"&tok=" +
		patientToken +
		"&discount=" +
		discount;
	} else {
		redirectLink =
		env +
		".ottooptics.io/reorder/rxselect/?id=" +
		patientID +
		"&tok=" +
		patientToken;
	}
	} else {
	if (discount != null) {
		redirectLink =
		env +
		".ottooptics.io/reorder/product/?id=" +
		patientID +
		"&tok=" +
		patientToken +
		"&discount=" +
		discount;
	} else {
		redirectLink =
		env +
		".ottooptics.io/reorder/product/?id=" +
		patientID +
		"&tok=" +
		patientToken;
	}
	}

	return redirectLink;
}

function validateEmailOrMobile(input) {
	if (/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/gm.test(input)) {
		// The input looks like a phone number
		return 1
	} else if (/^\S+@\S+\.\S+$/.test(input)) {
		// The input looks like an email
		return 2
	} else {
		// Invalid input
		return 0;
	}
}

function formatPhoneNumber(phoneNumber) {
	// Remove any non-digit characters from the input
	let digits = phoneNumber.replace(/\D/g, "");
	digits = digits.substr(digits.length - 10, digits.length);

	// Check if the remaining digits form a valid phone number
	const phoneNumberPattern = /^(\d{3})(\d{3})(\d{4})$/;
	if (phoneNumberPattern.test(digits)) {
	// Format the phone number as (###) ###-####
	return digits.replace(phoneNumberPattern, "($1) $2-$3");
	} else {
	return "Invalid Phone Number";
	}
}

function allEventHandlers() {
	document
	.getElementById("btn-returning-patient")
	?.addEventListener("click", function (e) {
		document.querySelectorAll(".preid-content").forEach(function (element) {
		element.style.display = "none";
		});

		document.querySelectorAll(".login-content").forEach(function (element) {
		element.style.display = "";
		});
	});

	let patientID = null;
	let redirectLink = null;
	let env = document.location.hostname.split(".")[0];

	document.getElementById("emailOrPhone")
	?.addEventListener("keypress", function (e) {
		if (e.key === "Enter") {
		e.preventDefault();
		document.getElementById("patient-create-session").click();
		}
	});

	/* submit the form */
	document.getElementById("patient-create-session")
	?.addEventListener("click", function (e) {
		e.preventDefault();
		
		// Check if page is in an iframe
		if (window.location !== window.parent.location) {
			// Get current URL and parameters
			let currentUrl = window.location.href;
			
			window.open(currentUrl, '_blank');
			
			return false;
		}
		
		document.getElementById("button-text").style.display = "none";
		document.getElementById("patient-session-loader").style.display = "";
		document.getElementById("verification-code").value = "";

		if (validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 0) {
			document.getElementById("button-text").style.display = "block";
			document.getElementById("patient-session-loader").style.display =
				"none";
			document.getElementById("email-or-phone-err").style.display = "block"
			setTimeout(function () {
				document.getElementById("email-or-phone-err").style.display = "none";
			}, 10000);
			return;
		} else {
			var patientRedirectLinkInput = document.getElementById("factorRedirectLink")
			var patientRequestTokenInput = document.getElementById("factorPatientRequestToken");
			var patientLocationID = document.getElementById("factorLocationID");

			fetch(
				"https://" +
				document.location.hostname +
				"/api/v2/2FA/Send2FACode.php",
				{
				redirect: "error",
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					email: validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 2 ? document.getElementById("emailOrPhone").value: "",
					mobile: validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 1 ? formatPhoneNumber(document.getElementById("emailOrPhone").value): "",
					redirectLink: patientRedirectLinkInput ? patientRedirectLinkInput.value : "",
					patientRequestToken: patientRequestTokenInput ? patientRequestTokenInput.value : "",
					patientLocationID: patientLocationID ? patientLocationID.value : ""
				}),
				}
			)
			.then((response) => response.json())
			.then((res) => {
				let toProductStoreModalInfo = document.getElementById("to-product-store-modal-info");
				let toProductStoreModalMessage = document.getElementById("to-product-store-modal-message");
				if (typeof res.message !== 'undefined') {
					toProductStoreModalInfo.style.display = "none";
					toProductStoreModalMessage.style.display = "block";
					toProductStoreModalMessage.textContent = res.message;
				} else {
					toProductStoreModalInfo.style.display = "block";
					toProductStoreModalMessage.style.display = "none";
					toProductStoreModalMessage.textContent = "";
				}
				document.getElementById("button-text").style.display = "block";
				document.getElementById("patient-session-loader").style.display =
					"none";
				if (res.status == 200) {
					$.magnificPopup.open({
					items: {
						src: "#verification-modal",
					},
					type: "inline",
					removalDelay: 300,
					mainClass: "mfp-zoom-in",
					});

					patientID = res.patientID;
				} else {
					$.magnificPopup.open({
						items: {
							src: "#to-product-store-modal",
						},
						type: "inline",
						removalDelay: 300,
						mainClass: "mfp-zoom-in",
					});
				}
			}).catch((e) => {
				console.error(e);
			});
		}
	});

	document.getElementById("verification-action")
	?.addEventListener("click", function (e) {
		var verificationCodeInput = document.getElementById("verification-code");
		var verificationError = document.getElementById("verification-error");
		var verificationButtonText = document.getElementById(
		"verification-button-text"
		);
		var verificationLoader = document.getElementById("verification-loader");

		if (verificationCodeInput.value.length === 0) {
		verificationError.style.display = "block";
		verificationError.textContent = i18next.t('please_enter_a_code', { ns : 'reorder'});
		setTimeout(function () {
			verificationError.style.display = "none";
			verificationError.textContent = "";
		}, 3000);
		return;
		}

		if (verificationCodeInput.value.length !== 6) {
		verificationError.style.display = "block";
		verificationError.textContent = i18next.t('the_code_should_be_6_digits', { ns : 'reorder'});
		setTimeout(function () {
			verificationError.style.display = "none";
			verificationError.textContent = "";
		}, 3000);
		return;
		}

		verificationButtonText.style.display = "none";
		verificationLoader.style.display = "block";
		
		var patientRequestTokenInput = document.getElementById("factorPatientRequestToken");
		// validate the 2FA code
		fetch(
				"https://" +
				document.location.hostname +
				"/api/v2/2FA/Validate2FACode.php",
			{
				redirect: "error", 
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					id: patientID,
					patientToken: patientRequestTokenInput ? patientRequestTokenInput.value : '',
					code: verificationCodeInput.value,
					email: validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 2 ? document.getElementById("emailOrPhone").value: "",
					mobile: validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 1 ? formatPhoneNumber(document.getElementById("emailOrPhone").value): "",
				}),
			}
		)
		.then((response) => response.json())
		.then((res) => {
			var verificationButtonText = document.getElementById(
			"verification-button-text"
			);
			var verificationLoader = document.getElementById(
			"verification-loader"
			);
			var verificationError = document.getElementById("verification-error");

			if (res.status == 400) {
			verificationButtonText.style.display = "block";
			verificationLoader.style.display = "none";
			verificationError.style.display = "block";
			verificationError.textContent = res.message;

			setTimeout(function () {
				verificationError.style.display = "none";
				verificationError.textContent = "";
			}, 10000);
			return;
			}

			if (res.status == 404) {
			verificationButtonText.style.display = "block";
			verificationLoader.style.display = "none";
			verificationError.style.display = "block";
			verificationError.textContent = res.message;

			setTimeout(function () {
				verificationError.style.display = "none";
				verificationError.textContent = "";
			}, 10000);
			return;
			}

			if (res.status == 200) {

			let url = new URL(window.location.href);
			let discount = url.searchParams.get("discount");
			
			redirectLink = res.orderLink;

			if (discount != null) {
				redirectLink += "&discount=" + discount;
			}

			} else {
			alert(i18next.t('we_had_a_problem_processing_your_request_please_try_again', { ns : 'reorder'}) + '.');
			}

			verificationButtonText.style.display = "block";
			verificationLoader.style.display = "none";

			window.location.href = redirectLink;
		})
		.catch((e) => {
			console.error(e);
		});
	});

	document.getElementById("resend-code-action")
	?.addEventListener("click", function (e) {
		e.preventDefault();
		document.getElementById("resend-code-button-text").style.display = "none";
		document.getElementById("resend-code-loader").style.display = "";
		document.getElementById("verification-code").value = "";
		document.getElementById("verification-button-text").style.display = "";
		document.getElementById("verification-loader").style.display = "none";

		fetch(
		"https://" + document.location.hostname + "/api/v2/2FA/Send2FACode.php",
		{
			redirect: "error",
			method: "POST",
			headers: {
			"Content-Type": "application/json",
			},
			body: JSON.stringify({
				email: validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 2 ? document.getElementById("emailOrPhone").value: "",
				mobile: validateEmailOrMobile(document.getElementById("emailOrPhone").value) === 1 ? formatPhoneNumber(document.getElementById("emailOrPhone").value): "",
			}),
		}
		)
		.then((response) => response.json())
		.then((res) => {
			let resendCodeButtonText = document.getElementById(
			"resend-code-button-text"
			);
			let resendCodeLoader = document.getElementById("resend-code-loader");
			let verificationInfo = document.getElementById("verification-info");

			resendCodeButtonText.style.display = "block";
			resendCodeLoader.style.display = "none";
			if (res.status == 200) {
				verificationInfo.style.display = "block";
				verificationInfo.textContent = i18next.t('a_new_verification_code_has_been_sent_to_you', { ns : 'reorder'}) + '.';
				setTimeout(function () {
					verificationInfo.style.display = "none";
					verificationInfo.textContent = "";
				}, 3000);
			} else {
				alert(i18next.t('we_had_a_problem_processing_your_request_please_try_again', { ns : 'reorder'}) + '.');
			}
		}).catch((e) => {
			console.error(e);
		});
	});

	document.getElementById("to-product-store-continue-action")?.addEventListener("click", function (e) {
	window.location.href = "https://" + document.location.hostname + "/reorder/product/";
	});

	document.getElementById("to-product-store-no-action")?.addEventListener("click", function (e) {
	$.magnificPopup.close();
	});

	// multiple patients select
	try{
	if (patientList) {
		// open pop up to select patient
		var multiPatientSelect = document.getElementById(
		"multi-patient-select"
		);
		multiPatientSelect.innerHTML = "";

		patientList.forEach(function (item) {
		var option = document.createElement("option");
		let url = new URL(window.location.href);
		let discount = url.searchParams.get("discount");
		option.value =
			"https://" +
			createRedirectLink(
			env,
			item.patient_id,
			item.rxcount,
			item.patient_requestToken,
			discount
			);
		option.text =
			item.patient_firstName + " " + item.patient_lastName;
		multiPatientSelect.appendChild(option);
		});

		$.magnificPopup.open({
		items: {
			src: "#patient-select-modal",
		},
		type: "inline",
		removalDelay: 300,
		mainClass: "mfp-zoom-in",
		});
	}
	} catch (e) {}

	var choosePatientAction = document.getElementById("choose-patient-action");
	var multiPatientSelect = document.getElementById("multi-patient-select");

	choosePatientAction?.addEventListener("click", function (e) {
	var selectedValue = multiPatientSelect.value;
	if (selectedValue) {
		window.location.href = selectedValue;
	}
	});
}
jQuery(document).ready(function () {
	allEventHandlers();
});
